import { gql, useLazyQuery } from "@apollo/client";
import { ListPortPickupQuery } from "../gql/graphql";

const LIST_PORT_BY_LOCATION_QUERY = gql`
  query listPortByLocation($input: ListPortByLocationInput!) {
    listPortByLocation(input: $input) {
      ok
      err
      ports {
        id
        name
        address
        usageTime
        phone
        author {
          id
          name
          phone
        }
        regionKeyWord
        linkService {
          id
          name
        }
        latitude
        longitude
      }
    }
  }
`;

export interface ListPortByLocationInput {
  serviceId: number;
}

export interface ListPortByLocationQuery {
  listPortByLocation: {
    ok: boolean;
    err: string;
    ports: {
      id: number;
      name: string;
      address: string;
      usageTime: string;
      phone: string;
      author: {
        id: number;
        name: string;
        phone: string;
      };
      regionKeyWord: string;
      linkService: {
        id: number;
        name: string;
      };
      latitude: number;
      longitude: number;
    }[];
  };
}

export interface GetPortByLocationQuery {
  getPortByLocation: {
    ok: boolean;
    err: string;
    port: {
      id: number;
      name: string;
      address: string;
      usageTime: string;
      phone: string;
      author: {
        id: number;
        name: string;
        phone: string;
      };
      regionKeyWord: string;
      linkService: {
        id: number;
        name: string;
      };
      latitude: number;
      longitude: number;
    };
  };
}

export const useListPortByLocation = (
  onCompleted?: (data: ListPortByLocationQuery) => void
) => {
  return useLazyQuery<ListPortByLocationQuery>(LIST_PORT_BY_LOCATION_QUERY, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
